import type { TranslationTree } from '../../types';

export const contact: TranslationTree = {
  contact: {
    intro: {
      badge: 'Contact',
      title: "Contacter l'équipe ToolLife",
      description:
        'Remplissez le formulaire pour ouvrir un e-mail pré-rempli dans votre client de messagerie.',
      highlights: {
        question: {
          title: 'Poser une question',
          description:
            'Décrivez votre besoin — nous lirons votre message et répondrons par e-mail.',
        },
        bug: {
          title: 'Signaler un bug',
          description: 'Précisez le module concerné et les étapes pour reproduire le problème.',
        },
        followUp: {
          title: "Suggestion d'amélioration",
          description:
            "Partagez vos idées pour améliorer l'application ou demandez une nouvelle fonctionnalité.",
        },
      },
    },
    form: {
      badge: 'Formulaire de contact',
      title: 'Envoyez-nous un message',
      description:
        'Remplissez les champs ci-dessous — cliquer sur envoyer ouvrira votre client mail avec le message prêt à partir.',
      contactInfo: {
        title: 'Adresse directe',
        copyCta: "Copier l'adresse",
        copySuccess: 'Adresse copiée !',
        copyError: 'Copie impossible sur cet appareil.',
      },
      fields: {
        subjectLabel: 'Sujet',
        subjectPlaceholder: 'Ex. Problème de synchronisation du scanner',
        categoryLabel: 'Type de demande',
        categoryPlaceholder: 'Sélectionner',
        messageLabel: 'Message',
        messagePlaceholder:
          'Décrivez votre question ou le bug rencontré, avec les étapes de reproduction si possible.',
      },
      categories: {
        bug: 'Bug ou anomalie',
        question: "Question d'utilisation",
        improvement: "Suggestion d'amélioration",
        other: 'Autre',
        fallback: 'Demande',
      },
      copy: {
        notAvailable: 'Copie non disponible sur cet appareil.',
      },
      emailFallback: 'Adresse non communiquée',
      mail: {
        subject: '{{category}} - {{subject}}',
        body: 'Type de demande : {{category}}\n---\nExpéditeur : {{author}}\n---\n{{message}}\n',
      },
      status: {
        successTitle: 'Votre client mail a été ouvert.',
        successDescription:
          'Pensez à vérifier le contenu avant envoi et à nous ajouter des captures si nécessaire.',
        errorDefault: "Impossible d'ouvrir votre client mail.",
        opening: 'Ouverture en cours…',
      },
      actions: {
        openClient: 'Ouvrir mon client mail',
        reset: 'Réinitialiser le formulaire',
        back: 'Retour',
      },
    },
  },
};
